import { render } from "./SentenceList.vue?vue&type=template&id=9ddb32ca&scoped=true"
import script from "./SentenceList.vue?vue&type=script&lang=js"
export * from "./SentenceList.vue?vue&type=script&lang=js"

import "./SentenceList.vue?vue&type=style&index=0&id=9ddb32ca&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ddb32ca"]])

export default __exports__